var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47643 8.00018C6.47643 7.1586 7.15866 6.47638 8.00023 6.47638C8.8418 6.47638 9.52403 7.1586 9.52403 8.00018C9.52403 8.84175 8.8418 9.52398 8.00023 9.52398C7.15866 9.52398 6.47643 8.84175 6.47643 8.00018Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7044 8.86392C16.0988 8.34876 16.0988 7.65217 15.7044 7.13618C14.4618 5.51413 11.4807 2.17432 8.00023 2.17432C4.51977 2.17432 1.53866 5.51413 0.296117 7.13618C0.104187 7.38325 0 7.68719 0 8.00005C0 8.31291 0.104187 8.61686 0.296117 8.86392C1.53866 10.486 4.51977 13.8258 8.00023 13.8258C11.4807 13.8258 14.4618 10.486 15.7044 8.86392ZM8.00023 4.95257C6.31709 4.95257 4.95263 6.31703 4.95263 8.00018C4.95263 9.68332 6.31709 11.0478 8.00023 11.0478C9.68338 11.0478 11.0478 9.68332 11.0478 8.00018C11.0478 6.31703 9.68338 4.95257 8.00023 4.95257Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.2e43d82859e88e65a8bf8baf42044fe0.svg";
export { ForwardRef as ReactComponent };